var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.6,28.7H18.5a.9.9,0,0,1-.8-.8V21.8c0-1.2-.7-2.1-1.7-2.1s-1.7.9-1.7,2.1v6.1a.9.9,0,0,1-.8.8H5.4a.8.8,0,0,1-.7-.8V12.7a.8.8,0,0,1,.2-.5l10-8.5a1.8,1.8,0,0,1,2.2,0l10,8.5a.8.8,0,0,1,.2.5V27.9A.8.8,0,0,1,26.6,28.7Zm-7.4-1.5h6.6V13.1L16.1,4.9c-.1-.1-.1-.1-.2,0L6.2,13.1V27.2h6.6V21.8A3.4,3.4,0,0,1,16,18.2a3.4,3.4,0,0,1,3.2,3.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaHome);
export default __webpack_public_path__ + "static/media/ga-home.4fecee05.svg";
export { ForwardRef as ReactComponent };